/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { isWindows } from "react-device-detect";
import { createGlobalStyle, css } from "styled-components";

/* -------------------------------------------------- */
/*                 Responsive Design                  */
/* -------------------------------------------------- */

export const DEVICE = {
  small: "530px",
  medium: "767px",
  large: "1024px",
};

/* -------------------------------------------------- */
/*                  Global CSS Styles                 */
/* -------------------------------------------------- */
export const GlobalStyles = createGlobalStyle`
  body {
    background-color: ${({ theme }) => {
      return theme.background;
    }}
  }

  // override background color to white on print
  @media print {
    body {
      background-color: #FFF; // white
    }
  }

.form-control:focus {
  outline: none;
}

.title-input {
  outline-offset: 3px;
}

.title-input:hover {
  background-color: #888888;
}
.title-input:focus-within {
  outline: ${({ theme }) => `2px solid ${theme.primary}`}
}

/* use custom scroll bars on windows browser and windows electron */
${() => {
  if (isWindows) {
    return css`
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        background: transparent;
      }

      ::-webkit-scrollbar-thumb {
        background: #d3d1cb;
      }
      ::-webkit-scrollbar-track {
        background: #edece9;
      }
    `;
  }
  return "";
}}
`;
